import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=b0a95aa2&scoped=true&"
import script from "./FileBrowser.vue?vue&type=script&lang=js&"
export * from "./FileBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=b0a95aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a95aa2",
  null
  
)

export default component.exports